// /business, the business side's index (PRD 89 §4.12). The dashboard there is
// closed to both field roles (cash, AR, AP, net income), so a technician or a
// dispatcher is sent to their own page instead — My profile, or the field
// service Overview — and never sees a refusal, or the books, on arrival.
//
// The role is the CURRENT business's: someone who keeps the books in one
// business and is a technician in another sees each business as its role
// allows. Presentation only; the api's RestrictedRoleGate is the security.

import React from 'react';
import { Navigate } from 'react-router-dom';
import { useBusinessOptional } from '../../contexts/BusinessContext';
import { fieldRoleHomePath } from './fieldRoleLanding';

export const BusinessIndexRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const business = useBusinessOptional();
  const home = fieldRoleHomePath(business?.currentBusiness?.role);
  if (home) return <Navigate to={home} replace />;
  return <>{children}</>;
};

export default BusinessIndexRoute;
